import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n"

const useVideoCollection = () => {
  const { locale } = useLocalization()

  const data = useStaticQuery(graphql`
    query AllCollectionVideosQuery {
      videos: allCollectionVideos {
        nodes {
          id
          title
          teaserText
          topics {
            id
            title
            url
          }
          poster {
            alt
            localImage {
              childImageSharp {
                gatsbyImageData(width: 800, height: 450)
              }
            }
          }
          url
          locale
        }
      }
    }
  `)

  /**
   * Get all Videos in the current locale
   */
  return React.useMemo(
    () => data.videos.nodes.filter(n => n.locale === locale),
    [data, locale]
  )
}

export default useVideoCollection
